import { getContext } from "svelte";
import type { GlobalSettings } from "./GlobalSettings.js";
import { globalSettingsContextKey } from "./GlobalSettings.js";

export function getGlobalSettings(): GlobalSettings {
	return getContext<GlobalSettings>(globalSettingsContextKey);
}
